import { useState, useEffect } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { logout } from '../../store/slices/usuario';
import { estadoEdicion } from '../../store/slices/edicion';
// mui components
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import WidgetsIcon from '@mui/icons-material/Widgets';
// mui icons
import EditIcon from '@mui/icons-material/Edit';
import Logout from '@mui/icons-material/Logout';
import { ListItemText } from '@mui/material';

const MenuEdicion = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { usuario } = useSelector((state: RootState) => state.usuario);
  const { curso } = useSelector((state: RootState) => state.curso);

  const { edicion } = useSelector((state: RootState) => state.edicion);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [rolUsuarioCurso, setRolUsuarioCurso] = useState('');

  useEffect(() => {
    if (usuario?.cursos) {
      const cursoUsuario = usuario.cursos.find(item => item.cid === curso.cid);
      setRolUsuarioCurso(cursoUsuario?.rol ? cursoUsuario.rol : '')
    }
  }, [curso, usuario])
  

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    console.log('Logout');
    dispatch(logout())
  }

  const handleEdicion = () => {
    dispatch(estadoEdicion(edicion))
  }

  return (
    <>
       <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center'}}>
         <Tooltip title="Menú">
           <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>
              <WidgetsIcon />
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >

        {
          rolUsuarioCurso === 'Administrador' &&
          <MenuItem
            onClick={() => handleEdicion()}
          >
            <ListItemIcon>
              {edicion ? <EditIcon fontSize="small" color="warning"/> : <EditIcon fontSize="small" />}
            </ListItemIcon>
              {edicion ? <ListItemText primary='Desactivar Edición' /> : <ListItemText primary='Activar Edición' />}
          </MenuItem>
        }
        
        <MenuItem
          onClick={() => handleLogout()}
        >
          <ListItemIcon>
            <Logout fontSize="small" color="primary"/>
          </ListItemIcon>
          <ListItemText primary='Logout' />
        </MenuItem>
      </Menu>
    </>
  )
}

export default MenuEdicion;